import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import { getContextReference, getContextReferenceEventAgentId, getContextReferenceVariableName } from "./getContextReference.js";
import { parseElement } from "./parseElement.js";
export function parseContextProvider(path, context, state, app, options) {
  var contextReference = getContextReference(context, state, app, options);
  var elements = path.get("children").flatMap(function (child) {
    return parseElement(child, state, app, options);
  });
  if (!contextReference) {
    return elements;
  }
  var openingElement = path.get("openingElement");
  var attrValuePath;
  var _iterator = _createForOfIteratorHelper(openingElement.get("attributes")),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var attr = _step.value;
      if (attr.isJSXSpreadAttribute()) {
        state.errors.push({
          message: "Spread attributes are not supported in component",
          node: attr.node,
          severity: "error"
        });
        continue;
      }
      var attrNamePath = attr.get("name");
      if (!attrNamePath.isJSXIdentifier()) {
        state.errors.push({
          message: "Expected JSXIdentifier, but got ".concat(attrNamePath.node.type),
          node: attrNamePath.node,
          severity: "error"
        });
        continue;
      }
      var attrName = attrNamePath.node.name;
      if (attrName !== "value") {
        state.errors.push({
          message: "Unsupported attribute \"".concat(attrName, "\" in Context Provider"),
          node: attr.node,
          severity: "error"
        });
        continue;
      }
      attrValuePath = attr.get("value");
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (!attrValuePath) {
    state.errors.push({
      message: "Context Provider is missing required \"value\" attribute",
      node: openingElement.node,
      severity: "error"
    });
    return elements;
  }
  if (!attrValuePath.isJSXExpressionContainer()) {
    var _attrValuePath$node;
    state.errors.push({
      message: "Expected JSXExpressionContainer, but got ".concat((_attrValuePath$node = attrValuePath.node) === null || _attrValuePath$node === void 0 ? void 0 : _attrValuePath$node.type),
      node: attrValuePath.node,
      severity: "error"
    });
    return elements;
  }
  var expression = attrValuePath.get("expression");
  if (!expression.isObjectExpression()) {
    state.errors.push({
      message: "Context Provider \"value\" must be an object expression, but got ".concat(expression.node.type),
      node: expression.node,
      severity: "error"
    });
    return elements;
  }
  var properties = expression.get("properties");
  var stateSetters = new Map();
  var stateGetters = new Map();
  var _iterator2 = _createForOfIteratorHelper(properties),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var prop = _step2.value;
      if (!prop.isObjectProperty()) {
        state.errors.push({
          message: "Unsupported property type in Context Provider value: ".concat(prop.type),
          node: prop.node,
          severity: "error"
        });
        continue;
      }
      if (prop.node.computed) {
        state.errors.push({
          message: "Context Provider value property cannot be computed",
          node: prop.node,
          severity: "error"
        });
        continue;
      }
      if (!prop.node.shorthand) {
        state.errors.push({
          message: "Context Provider value property must use shorthand syntax",
          node: prop.node,
          severity: "error"
        });
        continue;
      }
      var value = prop.get("value");
      var bindingId = value.scope.getBindingIdentifier(value.node.name);
      var binding = void 0;
      if (bindingId) {
        var _options$component;
        binding = (_options$component = options.component) === null || _options$component === void 0 ? void 0 : _options$component.bindingMap.get(bindingId);
      }
      if (!binding) {
        state.errors.push({
          message: "No binding found for Context Provider value property \"".concat(value.node.name, "\""),
          node: value.node,
          severity: "error"
        });
        continue;
      }
      switch (binding.kind) {
        case "setState":
          stateSetters.set(value.node.name, binding.id.name);
          break;
        case "state":
          stateGetters.set(value.node.name, binding.id.name);
          break;
        default:
          state.errors.push({
            message: "Unsupported binding kind \"".concat(binding.kind, "\" for Context Provider value property \"").concat(value.node.name, "\""),
            node: value.node,
            severity: "error"
          });
          continue;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  if (stateSetters.size === 0) {
    return elements;
  }
  return [{
    type: "component",
    component: _objectSpread({
      name: "eo-event-agent",
      portal: true,
      properties: {
        id: getContextReferenceEventAgentId(contextReference.name)
      },
      events: {
        trigger: _toConsumableArray(stateSetters).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            setterName = _ref2[0],
            stateName = _ref2[1];
          return {
            action: "conditional",
            payload: {
              test: "<% EVENT.detail.name === ".concat(JSON.stringify(setterName), " %>"),
              consequent: {
                action: "update_variable",
                payload: {
                  name: stateName,
                  value: "<% EVENT.detail.value %>"
                }
              },
              alternate: null
            }
          };
        })
      }
    }, stateGetters.size > 0 ? {
      context: _toConsumableArray(stateGetters).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          getterName = _ref4[0],
          stateName = _ref4[1];
        return {
          name: getContextReferenceVariableName(contextReference.name, getterName),
          value: "<% CTX.".concat(stateName, " %>"),
          track: true
        };
      })
    } : undefined)
  }].concat(_toConsumableArray(elements));
}
//# sourceMappingURL=parseContextProvider.js.map